import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Stack, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import {
  SubscriptionPage,
  SubscriptionFormPage,
  CustomizedPlanBox,
  PurchaseFormPage,
} from '../sections/@dashboard/subscription';
import PurchaseCustomizeFormPage from '../sections/@dashboard/subscription/PurchaseCustomizeFormPage';
import { getPublicUrl } from '../config/site';

const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]          
      : theme.palette.background.paper, 

  padding: theme.spacing(2.5),
  borderRadius: 20,

  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 0px 10px rgba(0, 0, 0, 0.15)'
      : '0px 0px 10px rgba(0, 0, 0, 0.6)',
}));

export default function SubscriptionPricingPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isPurchaseFormOpen, setIsPurchaseFormOpen] = useState(false);
  const [isPurchaseCustomizeFormOpen, setIsPurchaseCustomizeFormOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  const openForm = (planId) => {
    setSelectedPlan(planId);
    setIsFormOpen(true);
  };
  const closeForm = () => {
    setIsFormOpen(false);
    navigate('/dashboard/subscription');
  };

  const openPurchaseForm = (planId) => {
    setSelectedPlan(planId);
    setIsPurchaseFormOpen(true);
  };

  const closePurchaseForm = () => {
    setIsPurchaseFormOpen(false);
    navigate('/dashboard/subscription');
  };

  const openPurchaseCustomizeForm = (planId) => {
    setSelectedPlan(planId);
    setIsPurchaseCustomizeFormOpen(true);
  };

  const closePurchaseCustomizeForm = () => {
    setIsPurchaseCustomizeFormOpen(false);
    navigate('/dashboard/subscription');
  };
  const pageUrl = getPublicUrl('/dashboard/subscription');
  const imageUrl = getPublicUrl('/Logo/watch-nod.png');

  return (
    <>
      <Helmet>
        <title>Subscription Pricing | WatchNod</title>
        <meta
          name="description"
          content="Explore flexible subscription plans on WatchNod. Choose the perfect plan for your needs, customize features, and manage your subscription with ease."
        />
        <meta
          name="keywords"
          content="subscription plans, WatchNod subscriptions, flexible plans, customized subscription, pricing options"
        />
        <meta name="author" content="WatchNod Team" />
       
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <h1>
            <Typography variant="h3" gutterBottom>
              Subscription
            </Typography>
          </h1>
        </Stack>
        <StyledCard>
          <SubscriptionPage openForm={openForm} openPurchaseForm={openPurchaseForm} />
        </StyledCard>
        <Dialog open={isFormOpen} onClose={closeForm}>
          <StyledCard>
            <SubscriptionFormPage closeForm={closeForm} selectedPlan={selectedPlan} />
          </StyledCard>
        </Dialog>
        <Dialog open={isPurchaseFormOpen} onClose={closePurchaseForm}>
          <StyledCard>
            <PurchaseFormPage closePurchaseForm={closePurchaseForm} selectedPlan={selectedPlan} />
          </StyledCard>
        </Dialog>

        <Dialog open={isPurchaseCustomizeFormOpen} onClose={closePurchaseCustomizeForm}>
          <StyledCard>
            <PurchaseCustomizeFormPage
              closePurchaseCustomizeForm={closePurchaseCustomizeForm}
              selectedPlan={selectedPlan}
            />
          </StyledCard>
        </Dialog>
        <br />
        <StyledCard>
          <CustomizedPlanBox openPurchaseCustomizeForm={openPurchaseCustomizeForm} />
        </StyledCard>
      </Container>
    </>
  );
}
